import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { ChevronDown, ChevronUp } from 'lucide-react';
/**
 * Move-up / move-down pair for the rows of an ordered list (report template
 * sections, request fields, teleconsultation routing rules). Side by side at
 * 32px (40px on touch screens): a stacked pair of small arrows puts both under
 * one fingertip and makes a mouse pixel-hunt (WCAG 2.2 asks for 24px).
 */
export function ReorderControls({ canMoveUp, canMoveDown, onMove, upLabel, downLabel, className, }) {
    const buttonClass = 'text-muted-foreground hover:text-foreground size-8 shrink-0 p-0 pointer-coarse:size-10';
    return (_jsxs("div", { className: cn('flex shrink-0 items-center', className), children: [_jsx(Button, { type: "button", variant: "ghost", size: "sm", className: buttonClass, disabled: !canMoveUp, onClick: () => onMove(-1), "aria-label": upLabel, children: _jsx(ChevronUp, { className: "h-4 w-4" }) }), _jsx(Button, { type: "button", variant: "ghost", size: "sm", className: buttonClass, disabled: !canMoveDown, onClick: () => onMove(1), "aria-label": downLabel, children: _jsx(ChevronDown, { className: "h-4 w-4" }) })] }));
}
